import infoIcon from './assets/info-embedded.svg';
import crossIcon from './assets/cross-embedded.svg';

export default {
  components: {
    infoIcon,
    crossIcon,
  },
  props: {
    content: {
      type: String,
      required: true,
    },
    contentPosition: {
      type: String,
      default: 'top-left',
    },
  },
  data() {
    return {
      isContentOpen: false,
    };
  },
  methods: {
    toggleContent() {
      if (this.isContentOpen) {
        return this.closeContent();
      }
      return this.openContent();
    },

    openContent() {
      this.isContentOpen = true;
      this.createEscapeEvent();
      this.createWindowEvent();
    },

    closeContent() {
      this.isContentOpen = false;
      window.removeEventListener('keyup', this.escapeEvent);
      window.removeEventListener('click', this.windowEvent);
    },

    createEscapeEvent() {
      this.escapeEvent = window.addEventListener('keyup', (evt) => {
        if (evt.keyCode === 27 && this.isContentOpen) {
          this.closeContent();
        }
      });
    },

    createWindowEvent() {
      this.windowEvent = window.addEventListener('click', this.closeContent);
    },
  },
  destroyed() {
    window.removeEventListener('keyup', this.escapeEvent);
    window.removeEventListener('click', this.windowEvent);
  },
};
